// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__41Ckj","options":"AnswerScale_options__16xIH","selected":"AnswerScale_selected__mCkMN"};